import { func } from 'prop-types';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RadioGroup } from 'components';
import { addUuid } from 'helpers';

const MembershipStep = ({ changeStep }) => {
  const { t } = useTranslation();
  const {
    formState: { isValid },
    isLoading,
    submitClasses
  } = useFormContext();

  const radioOptions = useMemo(
    () =>
      addUuid(
        [
          {
            name: 'membershipFee',
            value: 'alreadyPaidSubscription',
            label: 'auth:registration.steps.alreadyPaidSubscription'
          },
          {
            name: 'membershipFee',
            value: 'notMemberYet',
            label: 'auth:registration.steps.notMemberYet'
          }
        ],
        'registration-membership-fee-radio-'
      ),
    []
  );

  return (
    <>
      <RadioGroup
        radioOptions={radioOptions}
        rules={{ required: true }}
        groupLabel={t('auth:registration.steps.moreInfo')}
      />

      <button
        type="button"
        disabled={!isValid || isLoading}
        onClick={changeStep}
        className={submitClasses}
        data-test-id="membershipSubmitBtn"
      >
        {t('buttons.next')}
      </button>
    </>
  );
};

MembershipStep.propTypes = {
  changeStep: func.isRequired
};

export default MembershipStep;
